import Strings from "../core/data/Strings";
import { GameObject } from "../core/GameObject";
import ResizableScene from "../core/ResizableScene";
import GameColors from "../GameColors";
import PlayerData from "../PlayerData";
import { GameScene } from "../scenes/GameScene";
import ActionQueue from "../utils/ActionQueue";
import Fonts from "../utils/Fonts";
import LayoutUtils from "../utils/LayoutUtils";
import { LightningParticleEmitter } from "./LightningParticleEmitter";

export class SlamMeter extends GameObject {

	scene: GameScene;
	group: Phaser.GameObjects.Container;
	bg: Phaser.GameObjects.Image;
	imgStr: string;
	icon: Phaser.GameObjects.Image;
	slotBGs: Phaser.GameObjects.Image[] = [];
	slots: Phaser.GameObjects.Image[] = [];
	slotGlows: Phaser.GameObjects.Image[] = [];
	min: number;
	max: number;
	progress: number;
	maxProgress: number;
	flipOffset = false;
	tut: Phaser.GameObjects.Container;

	constructor(scene: GameScene) {
		super(scene);
		this.flipOffset = false;

		let numSlots = 6
		let spacing = 10;
		let slotHeight = 60;
		this.imgStr = "slamBG";
		let adjustAmt = 20;
		console.log(PlayerData.Instance.saveData.items["anvil"]);
		if (PlayerData.Instance.saveData.items["anvil"] as number > 5) {
			numSlots = 11;	
			spacing = 6;
			slotHeight = 48;
			this.imgStr = "slamBG11"
			adjustAmt = 23;
		}

		const group = this.group = scene.add.container();
		this.add(group);

		const maxHeight = 482;
		// const bg = scene.add.nineSlicedSprite(0, 0, "slamBG", 80, maxHeight + 80, 35, 35, 35, 35);
		const bg = this.bg = this.addImage(this.imgStr);
		bg.alpha = 0.5;
		group.add(bg);

		const icon = this.icon = this.addImage("slamIcon");
		this.setSize(icon.width, 600);
		group.add(icon);

		const tut = this.tut = scene.add.container();
		group.add(tut);
		const tutBG = scene.add.nineSlicedSprite(0, 0, "tutSlamBacker", 470, 248, 30, 30, 30, 30);
		const tutTriangle = scene.add.image(0, 0, "tutSlamTriangle");
		const platform = this.scene.game.device.os.desktop ? "Web" : "Mobile";
		const tutText = scene.add.text(0, 0, Strings.get("TutorialText2" + platform), {
			fontFamily: Fonts.MaliMedium,
			color: GameColors.WHITE,
			fontSize: this.scene.game.device.os.desktop ? "30px" : "28px",
			align: "left",
			wordWrap: {width: 420, useAdvancedWrap: true },
		});
		tutText.setLineSpacing(10);
		tut.add([tutBG, tutTriangle, tutText]);
		tut.setSize(tutBG.slicedWidth + tutTriangle.width, tutBG.slicedHeight);
		tutBG.x + tutTriangle.width/2;
		scene.alignTo.LeftCenter(tutTriangle, tutBG, 0, 0);
		scene.alignIn.Center(tutText, tutBG, 0, 0);
		tut.setAlpha(0);
		tut.setScale(0);

		this.slotBGs = [];
		for (let i = 0; i < numSlots; i++) {
			const slotBG = this.addImage("slamOff");
			this.slotBGs.push(slotBG);
			const slotFill = this.addImage("slamOn");
			this.slots.push(slotFill);
			const slotGlow = this.addImage("slamGlow");
			group.add([slotBG, slotFill, slotGlow]);
			this.slotGlows.push(slotGlow);
			slotGlow.setVisible(false);
			if (numSlots == 11) {
				slotBG.setScale(0.8);
				slotFill.setScale(0.8);
				slotGlow.setScale(0.8);
			}
			scene.time.addEvent({
				delay: 166 * (6-i), 
				callback: () => {
					this.scene.tweens.add({
						targets: slotGlow,
						alpha: 0, 
						yoyo: true,
						loop: -1,
						duration: 1000,
						ease: Phaser.Math.Easing.Quadratic.InOut,
					})
				},
				callbackScope: this,
			})
			
		}

		LayoutUtils.alignGrid(scene, this.slotBGs, bg, slotHeight + spacing, 1, 0, adjustAmt);
		LayoutUtils.alignGrid(scene, this.slots, bg, slotHeight + spacing, 1, 0, adjustAmt);
		LayoutUtils.alignGrid(scene, this.slotGlows, bg, slotHeight + spacing, 1, 0, adjustAmt);

		scene.alignIn.TopCenter(icon, bg, 0, 60);
		scene.alignTo.RightCenter(tut, this.slotBGs[this.slotBGs.length-1], 20, 0);

		scene.time.addEvent({
			delay: 100,
			callback: () => {
				const saveData = PlayerData.Instance.saveData;
				const emptyCount = this.slotBGs.length - PlayerData.getItemValue("anvil");
				for (let i = saveData.slamsUnlocked-1 + emptyCount; i >= emptyCount; i--) {
					this.slots[i].setVisible(false);
					this.slotGlows[i].setVisible(false);
					this.slotBGs[i].setTexture("slamLocked")
				}
			},
			callbackScope: this,
		});
	}

	setProgress(amt: number): void {
		const numSlots = PlayerData.getItemValue("anvil");
		let slotsCharged = 0;
		for (let i = 0; i < this.slots.length; i++) {

			const slot = this.slotBGs[this.slots.length - 1 - i];
			slot.setTexture((i < numSlots) ? "slamOff" : "slamLocked");
			const fill = this.slots[this.slots.length - 1 - i];
			let progress = this.progress = Phaser.Math.Clamp(amt, 0, 1);
			if (progress == 1) slotsCharged++;
			fill.setCrop(0, fill.height - fill.height * progress, fill.width, fill.height * progress);
			fill.alpha = (progress == 1) ? 1 : 0.5;
			this.slotGlows[this.slots.length - 1 - i].setVisible(progress == 1);
			amt -= 1;

		}
		this.icon.setTexture(slotsCharged > 0 ? "slamIcon" : "slamIconGrey");
	}

	slamFail(): void {
		this.bg.setTexture(this.imgStr + "Red");
		this.scene.time.delayedCall(400, () => {
			this.bg.setTexture(this.imgStr);
		});
		this.scene.tweens.add({
			targets: this.group,
			x: { from: 0, to: 5 },
			duration: 50,
			ease: Phaser.Math.Easing.Sine.InOut,
			repeat: 3,
			yoyo: true,
		});
	}

	useSlam(slams: number): void {
		const slamIndex = Math.floor(slams);
		const glow = this.scene.add.image(0, 0, "slamIconGlow");
		const icon = this.scene.add.image(0, 0, "slamOn");
		const slot = this.slotBGs[this.slotBGs.length - slamIndex - 1];
		glow.setPosition(slot.x, slot.y);
		icon.setPosition(slot.x, slot.y);
		this.group.addAt(glow, this.group.getIndex(slot));
		this.group.addAt(icon, this.group.getIndex(slot) + 1);
		const queue = new ActionQueue();
		queue.add(complete => {
			this.scene.tweens.add({
				targets: glow,
				scale: { from: 0, to: 1 },
				duration: 150,
				ease: Phaser.Math.Easing.Quadratic.Out,
				onComplete: complete,
			});
		});
		queue.add(complete => {
			this.scene.tweens.add({
				targets: glow,
				scale: { from: 0, to: 1.5 },
				alpha: { from: 1, to: 0 },
				duration: 150,
				ease: Phaser.Math.Easing.Linear,
				onComplete: () => glow.destroy(),
			});
		});
		queue.start();
		this.scene.tweens.add({
			targets: icon,
			scale: { from: 1, to: 1.5 },
			alpha: 0,
			duration: 300,
			ease: Phaser.Math.Easing.Linear,
		});

		const emitter = new LightningParticleEmitter(this.scene);
		this.group.add(emitter);
		emitter.setPosition(slot.x, slot.y);
		this.scene.addObject(emitter, "none");
	}

	playAddSlamAnim(): void {
		const saveData = PlayerData.Instance.saveData;
		const emptyCount = this.slotBGs.length - PlayerData.getItemValue("anvil");
		for (let i = saveData.slamsUnlocked-1 + emptyCount; i >= emptyCount; i--) {
			const timeline = this.scene.tweens.createTimeline();
			timeline.add({
				targets: [this.slots[i], this.slotGlows[i], this.slotBGs[i]],
				scale: this.slots[this.slots.length-1].scale * 0.7,
				duration: 200,
				delay: 100 * ((saveData.slamsUnlocked-1 + emptyCount) - i),
				onComplete: () => {
					this.slots[i].setVisible(true);
					this.slotGlows[i].setVisible(true);
					this.slotBGs[i].setTexture("slamOff");
				}
			});
			timeline.add({
				targets: [this.slots[i], this.slotGlows[i], this.slotBGs[i]],
				scale: this.slots[this.slots.length-1].scale,
				duration: 300,
				ease: Phaser.Math.Easing.Back.Out,
			});
			timeline.play();
		}
		saveData.slamsUnlocked = 0;
	}

}